// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f94f22bd","25":"69d55c1b","119":"326447fb","141":"06a886e4","410":"30d11620","453":"fb268b7e","761":"80bfdb3a"}[chunkId] + ".chunk.js";
};